import { render, staticRenderFns } from "./LayoutWithMenu.vue?vue&type=template&id=157595f0&scoped=true"
import script from "./LayoutWithMenu.vue?vue&type=script&lang=js"
export * from "./LayoutWithMenu.vue?vue&type=script&lang=js"
import style0 from "./LayoutWithMenu.vue?vue&type=style&index=0&id=157595f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157595f0",
  null
  
)

export default component.exports